<template>
  <div class="flex justify-center gap-2" data-test-id="vf-media-gallery-pagination">
    <div
      v-for="page in pages"
      :key="page"
      :aria-current="page === activePage + 1 || undefined"
      class="h-2 w-2 b b-grey-40 rounded-full"
      :class="{ 'bg-grey-10 b-grey-10 !b-black': page === activePage + 1 }"
    />
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  activePage: number
  pages: number
}>()
</script>
